"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.externalAuthorizationDefinition = void 0;
const firestore_1 = require("comodel/firestore");
exports.externalAuthorizationDefinition = (0, firestore_1.defineCollection)({
    collectionName: "externalAuthorization",
    idKey: "externalAuthorizationId",
    queryDefs: {
        list: ({ email, source }) => {
            return {
                queryParams: {
                    filter: { email, source },
                    // orderBy: [["createdAt", "desc"]],
                },
            };
        },
    },
    defaultValue: {},
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({ createdAt: Date.now() }, o), { updatedAt: Date.now() })),
});
